module.exports = __webpack_public_path__ + "img/GTF4.13127419.png";